export const DriverEmploymentType = {
    Unknown: 0,
    /** *Own staff* */
    InHouse: 1,
    /** *Logistics company* */
    Outsourced: 2,
};
